import { Component, Input, OnInit } from '@angular/core';
import { Novita } from 'src/app/models/books.model';

@Component({
  selector: 'app-giacenza-counter',
  templateUrl: './giacenza-counter.component.html',
  styleUrls: ['./giacenza-counter.component.scss']
})
export class GiacenzaCounterComponent implements OnInit {
  @Input() book:  Novita | null = null;
  scaduto = false;
  constructor() { }

  ngOnInit(): void {
      if (this.book) {
      const oggi = new Date();
      oggi.setHours(0, 0, 0, 0);

      const data = this.book.data_pubblicazione;

      const dataPubblicazione = new Date(
        Number(data.substring(0, 4)),
        Number(data.substring(4, 6)) - 1,
        Number(data.substring(6, 8))
      );

      dataPubblicazione.setHours(0, 0, 0, 0);

    this.scaduto = this.book.novita === '1' &&  dataPubblicazione < oggi;
      }
  }
}
